<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link to="/" class="logo">福利站</router-link>
      <button class="menu-toggle" @click="toggleMenu">
        <span :class="{ 'active': isMenuOpen }"></span>
        <span :class="{ 'active': isMenuOpen }"></span>
        <span :class="{ 'active': isMenuOpen }"></span>
      </button>
    </div>
    
    <div class="navbar-menu" :class="{ 'is-open': isMenuOpen }">
      <div class="menu-item-wrapper" v-for="(menu, index) in menus" :key="index">
        <div class="menu-trigger" @click="toggleSubmenu(index)">
          {{ menu.title }}
          <span class="arrow" :class="{ 'active': openSubmenuIndex === index }">▼</span>
        </div>
        <div class="dropdown-menu" :class="{ 'is-open': openSubmenuIndex === index }">
          <template v-if="menu.items && Array.isArray(menu.items)">
            <template v-for="(item, itemIndex) in menu.items" :key="itemIndex">
              <router-link 
                v-if="item && !item.target"
                :to="item.path || '/'"
                class="menu-item"
                @click="closeMenu"
              >
                {{ item ? item.name : '未命名菜单项' }}
              </router-link>
              <a 
                v-else-if="item && item.target"
                :href="item.path || '#'" 
                :target="item.target"
                class="menu-item external-link"
                @click="closeMenu"
              >
                {{ item ? item.name : '未命名链接' }}
                <span class="external-icon">↗</span>
              </a>
            </template>
          </template>
        </div>
      </div>
    </div>

    <div class="search-box">
      <input 
        type="text" 
        v-model="searchQuery"
        placeholder="搜索..."
        @keyup.enter="handleSearch"
      >
      <button @click="handleSearch">搜索</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      searchQuery: '',
      isMenuOpen: false,
      openSubmenuIndex: null,
      menus: [
        {
          title: '图片分类',
          items: [
            { name: '美腿丝袜', path: '/meitui' },
            { name: '秀人合集', path: '/xiuren' },
            { name: 'cosplay', path: '/cos' },
            { name: '网红精选', path: '/wanghon' },
            { name: '名站套图', path: '/mingzhan' }
          ]
        },
        {
          title: '国产视频',
          items: [
            { name: '91制片厂', path: '/video/91' },
            { name: '麻豆传媒', path: '/video/madou' },
            { name: '天美传媒', path: '/video/tianmei' },
            { name: '香蕉视频', path: '/video/xiangjiao' },
            { name: '蜜桃影音', path: '/video/mitao' },
            { name: '糖心视频', path: '/video/tangxin' }
          ]
        },
        {
          title: '动漫视频',
          items: [
            { name: '3D动漫', path: '/video/3d' },
            { name: '动漫中文字幕', path: '/video/anime' }
          ]
        },
        {
          title: '欧美视频',
          items: [
            { name: '欧美视频', path: '/video/oumei' }
          ]
        },
        {
          title: '日本视频',
          items: [
            { name: 'HD无码', path: '/video/hd' },
            { name: 'Madonna', path: '/video/madonna' },
            { name: 'MODD', path: '/video/modd' },
            { name: 'S1', path: '/video/s1' }
          ]
        },
        {
          title: 'TG资源',
          items: [
            { name: 'TgGallery', path: '/TgGallery' }
          ]
        },
        {
          title: '免费加速器 可以提升加载速度',
          items: [
            { name: '注册地址', path: 'https://nNkG.xiaohuojian.sbs/auth/register?code=nNkG', target: '_blank' },
            { name: '下载地址（电脑）', path: 'https://pan.kunlunfiles.us/SSPanel/huojian/rocket_pluto_v1211.exe', target: '_blank' },
            { name: '下载地址（手机）', path: 'https://pan.kunlunfiles.us/SSPanel/huojian/rocket_pluto_v128.apk', target: '_blank' }
          ]
        }
      ]
    }
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.$router.push(`/search?q=${encodeURIComponent(this.searchQuery.trim())}`)
        this.closeMenu()
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (!this.isMenuOpen) {
        this.openSubmenuIndex = null
      }
    },
    toggleSubmenu(index) {
      if (window.innerWidth <= 768) {
        this.openSubmenuIndex = this.openSubmenuIndex === index ? null : index
      }
    },
    closeMenu() {
      this.isMenuOpen = false
      this.openSubmenuIndex = null
    }
  },
  mounted() {
    // 监听路由变化关闭菜单
    this.$router.afterEach(() => {
      this.closeMenu()
    })
    
    // 监听点击事件关闭菜单
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.closeMenu()
      }
    })

    // 调试菜单项
    console.log('Menus:', this.menus)
    this.menus.forEach((menu, index) => {
      console.log(`Menu ${index} (${menu.title}):`, menu.items)
      if (menu.items) {
        menu.items.forEach((item, i) => {
          if (!item || typeof item !== 'object') {
            console.error(`无效的菜单项 menu[${index}].items[${i}]:`, item)
          }
        })
      }
    })
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }
}
</script>

<style scoped>
.navbar {
  background: #1a1a1a;
  padding: 0.5rem 1rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.logo {
  color: #fff;
  font-size: 1.5rem;
  text-decoration: none;
  font-weight: bold;
  padding: 0.5rem 0;
}

.menu-toggle {
  display: none;
}

.navbar-menu {
  display: flex;
  gap: 1rem;
  flex: 1;
}

.menu-item-wrapper {
  position: relative;
}

.menu-trigger {
  color: #fff;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.arrow {
  font-size: 0.8em;
  transition: transform 0.3s;
}

.arrow.active {
  transform: rotate(180deg);
}

.menu-trigger:hover {
  background: #333;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  background: #1a1a1a;
  border-radius: 4px;
  padding: 0.5rem;
  margin-top: 0.5rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@media (min-width: 769px) {
  .menu-item-wrapper:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.menu-item {
  display: block;
  color: #fff;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.menu-item:hover {
  background: #333;
}

.external-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.external-icon {
  font-size: 0.8em;
  opacity: 0.7;
  margin-left: 5px;
}

.search-box {
  display: flex;
  gap: 0.5rem;
  min-width: 200px;
}

.search-box input {
  flex: 1;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  background: #333;
  color: #fff;
  min-width: 0;
}

.search-box button {
  padding: 0.5rem 1rem;
  background: #4CAF50;
  border: none;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.search-box button:hover {
  background: #45a049;
}

@media (max-width: 768px) {
  .navbar {
    flex-wrap: wrap;
    padding: 0.5rem;
  }

  .navbar-brand {
    width: 100%;
    justify-content: space-between;
  }

  .menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 21px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .menu-toggle span {
    display: block;
    width: 100%;
    height: 3px;
    background: #fff;
    transition: all 0.3s;
  }

  .menu-toggle span.active:nth-child(1) {
    transform: translateY(9px) rotate(45deg);
  }

  .menu-toggle span.active:nth-child(2) {
    opacity: 0;
  }

  .menu-toggle span.active:nth-child(3) {
    transform: translateY(-9px) rotate(-45deg);
  }

  .navbar-menu {
    display: none;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
  }

  .navbar-menu.is-open {
    display: flex;
  }

  .menu-item-wrapper {
    width: 100%;
  }

  .menu-trigger {
    justify-content: space-between;
    padding: 0.75rem 1rem;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    margin: 0;
    padding: 0 0 0 1rem;
    display: none;
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  .dropdown-menu.is-open {
    display: block;
  }

  .menu-item {
    padding: 0.75rem 1rem;
  }

  .search-box {
    width: 100%;
    margin-top: 0.5rem;
    order: -1;
  }
}
</style> 